module.exports = {"data":{"site":{"siteMetadata":{"descriptionLong":"Raise money for charity with every browser tab you open. It doesn't cost you a thing.","descriptionShort":"Raise money for charity with every browser tab you open.","keywords":"tab for a cause, charity, tab, cause, giving, extension, browser, advertising","metaTagCallToAction":"Join me on Tab for a Cause!","title":"Tab for a Cause","twitterHandle":"@TabForACause"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 394
// module chunks = 60335399758886 114276838955818